// AuthService.ts

export interface DecodedToken {
  role: string;
  channelName: string;
  // Add other claims as needed
}

export const decodeToken = (token: string): DecodedToken | null => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const decodedToken = JSON.parse(
    new TextDecoder().decode(
      new Uint8Array(
        Array.from(atob(base64), (c) => c.charCodeAt(0))
      )
    )
  );

  let role = '';
  let channelName = ''

  // Look for role claim in Microsoft namespace
  if (decodedToken && decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']) {
    role = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    channelName = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata']
  } else {
    console.error('Role claim not found');
    return null;
  }

  return {
    role,
    channelName,
    // Add other claims as needed
  };
};


